"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = void 0;
var reset = function (updateForm) { return function () {
    return updateForm({ key: "__no__Key", value: "__no__value", actionType: "reset" });
}; };
exports.reset = reset;
//# sourceMappingURL=reset.js.map